import React from 'react';
import styled from 'styled-components';

interface IJsonProps {
    json: unknown;
    caption?: string;
}

export const Json = ({ json, caption = 'JSON' }: IJsonProps) => {
    return (
        <details>
            <summary>{caption}</summary>
            <StyledPre>{JSON.stringify(json, undefined, 2)}</StyledPre>
        </details>
    );
};

const StyledPre = styled.pre`
    white-space: pre-wrap;
`;
